import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./accessControl.css";
import "../../global.css";
import Button from "@mui/material/Button";
import SaveIcon from "@mui/icons-material/Save";
import { useCompany } from "../../components/context/CompanyContext";
import { userRequest } from "../../requestMethods";
import Swal from "sweetalert2";
import { titleSetRef } from "../../redux/titleRedux";
import {
  PROFILES,
  SCREENS,
  SUB_SCREENS,
  canAccessScreen,
} from "../../util/accessControl";

export default function AccessControl() {
  const currentUser = useSelector((state) => state.user.currentUser);
  const { companyId } = useCompany();
  const dispatch = useDispatch();
  dispatch(titleSetRef({ title: "Controle de Acesso" }));
  const telas = SCREENS;
  const perfis = PROFILES;
  const [acesso, setAcesso] = useState();
  const canEdit =
    currentUser?.position === "Administrador" || currentUser?.position == null;

  useEffect(() => {
    if (companyId > 0) {
      userRequest.get(`company/find/${companyId}`).then((res) => {
        const raw = res.data?.accessControl;
        const parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
        // Empresa sem configuração precisa abrir a tabela vazia, senão não há
        // como marcar a primeira permissão.
        setAcesso(parsed || {});
      });
    }
  }, [companyId]);

  // Sub-tela mostra o valor efetivo (herda o pai quando não gravada), então o
  // clique inverte o efetivo e grava explícito.
  const handleChange = (tela, perfil) => {
    if (!canEdit) return;
    setAcesso((prev) => ({
      ...prev,
      [tela]: {
        ...(prev[tela] || {}),
        [perfil]: !canAccessScreen(prev, perfil, tela),
      },
    }));
  };

  // depth 0 = tela, 1 = dash, 2 = card. Abaixo da tela o checkbox mostra o
  // valor efetivo e fica travado enquanto o nível de cima estiver desmarcado.
  const renderRow = (key, label, depth, parent) => (
    <tr key={key} className={depth ? "ca-sub-row" : undefined}>
      <td className={depth ? `ca-td ca-td-sub ca-td-depth-${depth}` : "ca-td"}>
        {label}
      </td>
      {perfis.map((perfil) => (
        <td key={perfil} className="ca-td ca-td-center">
          <input
            type="checkbox"
            checked={
              depth
                ? canAccessScreen(acesso, perfil, key)
                : !!acesso[key]?.[perfil]
            }
            onChange={() => handleChange(key, perfil)}
            disabled={
              !canEdit || (depth > 0 && !canAccessScreen(acesso, perfil, parent))
            }
            aria-label={`${perfil} ${key}`}
          />
        </td>
      ))}
    </tr>
  );

  // Linha do nó seguida das linhas de todos os níveis abaixo dele.
  const renderTree = (node, depth, parent) => [
    renderRow(node.key, node.label, depth, parent),
    ...(node.children || []).flatMap((child) =>
      renderTree(child, depth + 1, node.key),
    ),
  ];

  const updateClick = async () => {
    try {
      const res = await userRequest.put(`${companyId}/company/`, {
        accessControl: acesso,
      });
      if (Object.keys(res.data).length > 0) {
        Swal.fire(
          "Parabéns!",
          "Controle de acesso alterado com sucesso!",
          "success",
        ).then(() => window.location.reload());
      } else {
        Swal.fire("Atenção!", "Erro ao alterar Controle de acesso!", "error");
      }
    } catch (error) {}
  };
  return (
    <div className="cust-page">
      <div className="cust-title">Controle de Acesso</div>
      <div className="cust-card">
        <div className="cust-section-header">Permissões por Perfil</div>
        <div style={{ padding: "16px" }}>
          <table className="ca-table">
            <thead>
              <tr>
                <th className="ca-th">Tela</th>
                {perfis.map((perfil) => (
                  <th key={perfil} className="ca-th">
                    {perfil}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {acesso &&
                telas.map((tela) => (
                  <Fragment key={tela}>
                    {renderRow(tela, tela, 0)}
                    {(SUB_SCREENS[tela] || []).flatMap((dash) =>
                      renderTree(dash, 1, tela),
                    )}
                  </Fragment>
                ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="cust-footer">
        {canEdit && (
          <Button
            variant="contained"
            color="secondary"
            size="small"
            startIcon={<SaveIcon />}
            onClick={updateClick}
          >
            Salvar
          </Button>
        )}
      </div>
    </div>
  );
}
